/**
 * BOOTSTRAP COLLAPSE HANDLER - Bootstrap-independent
 * Handles all collapse functionality: accordions, navbars, and collapsible panels
 * Replaces Bootstrap JS collapse plugin
 */

(function() {
  'use strict';

  function initCollapseHandler() {
    // Find all collapse toggles (accordions, navbars, etc.)
    const toggles = document.querySelectorAll('[data-bs-toggle="collapse"]');
    
    toggles.forEach(toggle => {
      const targetSelector = toggle.getAttribute('data-bs-target');
      if (!targetSelector) return;
      
      const target = document.querySelector(targetSelector);
      if (!target) return;
      
      // Handle click on toggle button
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          // Close the item
          closeCollapse(toggle, target);
        } else {
          // Open the item
          openCollapse(toggle, target);
        }
      });
      
      // Close on outside click (only for navbar, not accordions)
      // Accordions shouldn't close on outside click
      const isNavbar = target.id === 'navbarSupportedContent' || target.classList.contains('navbar-collapse');
      if (isNavbar) {
        document.addEventListener('click', function(e) {
          if (!toggle.contains(e.target) && !target.contains(e.target)) {
            if (toggle.getAttribute('aria-expanded') === 'true') {
              closeCollapse(toggle, target);
            }
          }
        });
        
        // Close on ESC key (only for navbar)
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
            closeCollapse(toggle, target);
          }
        });
      }
    });
  }
  
  function openCollapse(toggle, target) {
    // Check for accordion parent (data-bs-parent)
    // If present, close all sibling accordion items first
    const parentSelector = target.getAttribute('data-bs-parent');
    if (parentSelector) {
      const parent = document.querySelector(parentSelector);
      if (parent) {
        // Close all other items in the same accordion
        const siblings = parent.querySelectorAll('.accordion-collapse.show');
        siblings.forEach(sibling => {
          if (sibling !== target) {
            const siblingToggle = parent.querySelector(`[data-bs-target="#${sibling.id}"]`);
            if (siblingToggle) {
              closeCollapse(siblingToggle, sibling);
            }
          }
        });
      }
    }
    
    // Open the target
    toggle.setAttribute('aria-expanded', 'true');
    target.classList.add('show');
    target.classList.remove('collapse');
    
    // Add nav-open class only for navbar
    const isNavbar = target.id === 'navbarSupportedContent' || target.classList.contains('navbar-collapse');
    if (isNavbar) {
      document.body.classList.add('nav-open');
    }
    
    // Trigger custom event for other scripts (e.g., image switching in services)
    target.dispatchEvent(new CustomEvent('show.bs.collapse', { bubbles: true }));
  }
  
  function closeCollapse(toggle, target) {
    toggle.setAttribute('aria-expanded', 'false');
    target.classList.remove('show');
    target.classList.add('collapse');
    
    // Remove nav-open class only for navbar
    const isNavbar = target.id === 'navbarSupportedContent' || target.classList.contains('navbar-collapse');
    if (isNavbar) {
      document.body.classList.remove('nav-open');
    }
    
    // Trigger custom event for other scripts
    target.dispatchEvent(new CustomEvent('hide.bs.collapse', { bubbles: true }));
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapseHandler);
  } else {
    initCollapseHandler();
  }
})();
